/* LA REMISE A ZERO CSS DE TOUTE L'APPLICATION.
 *
 * ⛔ POURQUOI CE FICHIER MERITE DE L'ATTENTION. Il pose
 * `* { box-sizing: border-box; margin: 0; padding: 0 }` pour l'application
 * entiere. S'il cesse de s'appliquer, TOUT element combinant une largeur et un
 * remplissage change de taille — et pendant longtemps aucun filet ne l'aurait
 * vu : le banc des 87 empreintes monte les composants SANS ce fichier.
 * Deux detecteurs le gardent desormais :
 *   - `src/parcours/__tests__/D1-remise-a-zero-css.test.js` (le comportement) ;
 *   - `filet/lancer-prod.sh` (l'effet reel, dans Chrome).
 *
 * ⚠️ 23/09/2026 — PASSAGE DE JSS A EMOTION, ET POURQUOI PAS `@mui/styles`.
 * Ce fichier employait `makeStyles` + `createStyles` de l'ancien paquet de
 * styles de Material-UI.
 * La documentation officielle MUI dit de cette bibliotheque : « The legacy
 * styling solution for Material UI, now deprecated and not recommended for
 * use. It is **not compatible with React.StrictMode or React 18+**, and it will
 * not be updated. » Or l'application est deja en React 18 depuis R18-a, et
 * R18-b activera `createRoot`. La porter vers `@mui/styles` aurait donc pose un
 * cul-de-sac juste avant l'activation reelle de React 18.
 *
 * On passe donc directement a `@emotion/react`, qui est **deja installe** et
 * qui est le moteur de style de MUI v5 lui-meme. Ce choix ne depend d'aucune
 * version de MUI : il vaut avant comme apres la migration.
 *
 * ⛔ LES REGLES NE CHANGENT PAS D'UN CARACTERE. Seul le mecanisme change.
 */
import React from 'react'
import { Global } from '@emotion/react'

/* ⚠️ Emotion prend les selecteurs au premier niveau : il n'y a plus de bloc
   `@global` englobant, qui etait une notion propre a JSS. */
const reglesGlobales = {
  '*': {
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
  },
  html: {
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  },
  body: {
    backgroundColor: '#f4f6f8',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  },
  a: {
    textDecoration: 'none',
  },
  '#root': {
    height: '100%',
    width: '100%',
    fontFamily: 'Questrial !important',
  },
  '[contenteditable]': {
    cursor: 'text',
  },
  '[contenteditable]:focus': {
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
  },
  '[contenteditable]:focus-visible': {
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
  },
}

const GlobalStyles = () => <Global styles={reglesGlobales} />

export default GlobalStyles
